// @TODO: ideally, this should be merged with App/index.tsx
/*
 * Ryan O'Dowd
 * 2022-02-27
 *
 * © Copyright 2022 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import React, {
  useEffect,
  useRef,
  // @TODO: useState,
} from 'react';
import {
  fetchI18n,
  fetchMyClassroomsTeacher,
  // @TODO: fetchOrganizationCampaigns,
  // @TODO: fetchOrganizations,
  // @TODO: fetchParticipantCampaigns,
  fetchUser,
} from '@utils/store/actions';
import {
  Outlet,
} from 'react-router';
// @TODO: import Text from '@components/common/Text';
import fb from '@utils/firebase';
import hooks from '@hooks';

const WebsiteApp = () => {
  const dispatch = hooks.useTypedDispatch();
  const locationState = hooks.useLocationState();

  // @TODO: const [_authReady, setAuthReady] = useState(false);
  const userFetched = useRef(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [locationState]);

  useEffect(() => {
    const authUnsubscribe = fb.onAuthStateChanged(fb.auth, (authUser) => {
      if (authUser) {
        // onUserChanged fires multiple times each log in, so if this ref isn't used, this will fire 3 times and causes issues (performance for back end but also sign ups firing multiple times)
        if (!userFetched.current) {
          userFetched.current = true;
          dispatch(fetchUser());
          // @TODO: dispatch(fetchParticipantCampaigns()); // @TODO: don't think this is needed on web
          // @TODO: dispatch(fetchOrganizationCampaigns());
          // @TODO: dispatch(fetchOrganizations());
          dispatch(fetchMyClassroomsTeacher());
          // @TODO: redirect to page they were trying to log into?
          // @TODO: fb.setUserId(fb.crashlytics, authUser.uid);
          // @TODO: setAuthReady(true);
        }
      } else {
        // the user has logged out, so reset this
        userFetched.current = false;
      }

      dispatch(fetchI18n(1, true)); // @TODO: probably don't need archived ones unless we're in the i18n feature

      return () => authUnsubscribe();
    });
  }, [dispatch]);

  // @TODO: this caused a 25s delay on render in prod when logged in...
  // @TODO: if (!_authReady) { // @TODO: i don't think user needs to be authenticated for these routes...only if admin or schools? (actually, i18n as well...these could maybe be moved out though)
    // @TODO: this could be better...maybe a spinner. it's here so that no components are loaded until auth is determined; still don't like that there's a delay caused by returning null here
    // @TODO: return <Text>Loading...</Text>;
  // @TODO: }

  return (
    <Outlet />
  );
};

export default WebsiteApp;
